import { IonRangeSliderEvent, IonRangeSliderOptions } from "ion-rangeslider";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxCheck } from "../../Components/AxForm/AxCheck";
import { PlatformHelper } from "../../Lib/Helper/PlatformHelper";
import { ComplexPackageSelection } from "./ComplexPackageSelection";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { ComplexPackageSearchBar } from "./ComplexPackageSearchBar";

interface IComplexPackageFilterInit {
    currencyString: string;
    filterMin: number;
    filterMax: number;
    hideEmptyActivities: boolean;
    hideEmptyDuration: boolean;
    hideEmptySkiLevel: boolean;
    hideEmptyAgeGroup: boolean;
    hideEmptyContents: boolean;
}

@ModuleName("ComplexPackageFilter")
export class ComplexPackageFilter implements AxInit {
    private axLoading: AxLoading;
    private complexPackageSelectionModule: ComplexPackageSelection;
    private complexPackageSearchBarModule: ComplexPackageSearchBar;

    protected checkBoxesActivity: AxCheck[];
    protected checkBoxesContent: AxCheck[];
    protected checkBoxesDuration: AxCheck[];
    protected checkBoxesAgeGroups: AxCheck[];
    protected checkBoxesSkillLevels: AxCheck[];

    private identifierActivity = "identifierActivity_";
    private identifierDuration = "identifierDuration_";
    private identifierAgeGroup = "identifierAgeGroup_";
    private identifierSkillLevel = "identifierSkillLevel_";
    private identifierContent = "identifierContent_";
    private rangeSliderDesktop: any;
    private rangeSliderMobile: any;
    private priceRangeMin: number;
    private priceRangeMax: number;
    private hideEmptyActivities: boolean;
    private hideEmptyDuration: boolean;
    private hideEmptySkiLevel: boolean;
    private hideEmptyAgeGroup: boolean;
    private hideEmptyContents: boolean;

    AxInit(init: IComplexPackageFilterInit): void {
        this.axLoading = new AxLoading();

        this.checkBoxesActivity = [];
        this.checkBoxesContent = [];
        this.checkBoxesDuration = [];
        this.checkBoxesAgeGroups = [];
        this.checkBoxesSkillLevels = [];

        init.filterMax = init.filterMax / 100;
        init.filterMin = init.filterMin / 100;

        this.hideEmptyActivities = init.hideEmptyActivities;
        this.hideEmptyDuration = init.hideEmptyDuration;
        this.hideEmptySkiLevel = init.hideEmptySkiLevel;
        this.hideEmptyAgeGroup = init.hideEmptyAgeGroup;
        this.hideEmptyContents = init.hideEmptyContents;

        this.initCheckBoxes();
        this.initRangeSliderDesktop(init);
        this.initRangeSliderMobile(init);
        this.setChangeListeners();
        this.initMobile(init);
        this.complexPackageSelectionModule = AxLoad.GetModule<ComplexPackageSelection>("ComplexPackageSelection");
        this.complexPackageSearchBarModule = AxLoad.GetModule<ComplexPackageSearchBar>("ComplexPackageSearchBar");
        this.setupResetButtons();
        this.loadFilteredResults();
    }

    initMobile(init: IComplexPackageFilterInit) {
        $('body').on('click', '#compPacks-filter-open-button-mobile', () => {
            document.querySelector(".lessones_filter_mobile_holder.collapsible").classList.toggle("collapsed");;

            const compPackFilterFooter = <HTMLFormElement>document.getElementById('compPackFilterFooter');

            if (compPackFilterFooter.style.display !== 'flex') {
                compPackFilterFooter.style.display = 'flex';
            }

            $('.ax-header--fixed.ax-header-mobile--fixed').toggleClass('noscroll');
        });

        $('body').on('click', '#compackFilterMobileSafeButton', () => this.safeMobileFilter());

        $('body').on('click', '#filterCloseButtonMobile', () => this.closeMobileFilter());
    }

    // closeMobileFilter
    closeMobileFilter() {
        document.querySelector(".lessones_filter_mobile_holder.collapsible").classList.toggle("collapsed");;

        let compPackFilterFooter = <HTMLFormElement>document.getElementById('compPackFilterFooter');

        if (compPackFilterFooter.style.display !== 'none') {
            compPackFilterFooter.style.display = 'none';
        }

        $('.ax-header--fixed.ax-header-mobile--fixed').toggleClass('noscroll');
    }

    // safeMobileFilter
    safeMobileFilter() {
        this.closeMobileFilter();

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".compPacks_input_mask").offset().top - 59
        }, 500);
    }

    // initRangeSlider
    initRangeSliderDesktop(init: IComplexPackageFilterInit) {
        this.rangeSliderDesktop = $(".ax-range-slider.ax-compPack-desktopIdentifier").ionRangeSlider({
            skin: 'round',
            type: 'double',
            hide_min_max: true,
            extra_classes: 'ax-range-slider has-labels',
            prefix: `${init.currencyString} `,
            max: init.filterMax,
            min: init.filterMin,
            step: 2.5,
            onChange: x => this.setPriceFromSlider(x),
            onFinish: x => this.sliderUpdated(x),
            onStart: x => this.setPriceFromSlider(x),
            onUpdate: x => this.sliderUpdated(x)
        });
    }

    // initRangeSlider
    initRangeSliderMobile(init: IComplexPackageFilterInit) {
        this.rangeSliderMobile = $(".ax-range-slider.ax-compPack-mobileIdentifier").ionRangeSlider({
            skin: 'round',
            type: 'double',
            hide_min_max: true,
            extra_classes: 'ax-range-slider has-labels',
            prefix: `${init.currencyString} `,
            max: init.filterMax,
            min: init.filterMin,
            step: 2.5,
            onChange: x => this.setPriceFromSlider(x),
            onFinish: x => this.sliderUpdated(x),
            onStart: x => this.setPriceFromSlider(x),
            onUpdate: x => this.sliderUpdated(x)
        });
    }

    // sliderChanged
    sliderUpdated(x: IonRangeSliderEvent) {
        this.setPriceFromSlider(x);
        this.loadFilteredResults();
    }

    // setPriceFromSlider
    setPriceFromSlider(x: IonRangeSliderEvent) {
        this.priceRangeMin = x.from;
        this.priceRangeMax = x.to;
    }

    // initCheckBoxes
    initCheckBoxes() {
        $('.compPack_filter_item_activity').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_filter_item_activity').attr('data-activity-id');
            this.checkBoxesActivity.push(new AxCheck(this.identifierActivity + id, obj));
        });

        $('.compPack_filter_item_content').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_filter_item_content').attr('data-content-id');
            this.checkBoxesContent.push(new AxCheck(this.identifierContent + id, obj));
        });

        $('.compPack_filter_item_duration').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_filter_item_duration').attr('data-duration-id');
            this.checkBoxesDuration.push(new AxCheck(this.identifierDuration + id, obj));
        });

        $('.compPack_filter_item_ageGroup').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_filter_item_ageGroup').attr('data-ageGroup-id');
            this.checkBoxesAgeGroups.push(new AxCheck(this.identifierAgeGroup + id, obj));
        });

        $('.compPack_filter_item_skillLevel').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_filter_item_skillLevel').attr('data-skillLevel-id');
            this.checkBoxesSkillLevels.push(new AxCheck(this.identifierSkillLevel + id, obj));
        });
    }

    // setChangeListeners
    setChangeListeners() {
        $('.compPack_filter_item').change(() => {
            this.loadFilteredResults();
        });
    }
    // loadFilteredResults
    loadFilteredResults() {
        let data = this.prepareData();

        let compPacksResultsContainer = $('#compPacksResultsContainer')[0];
        let compPacksResultsSearchButton = $('.compPacks_input_mask_icon')[0];

        this.axLoading.ShowLoadingIndicatorTop(compPacksResultsContainer);
        //this.axLoading.ShowLoadingIndicatorButtonPrimary(compPacksResultsSearchButton);

        AxessViewer.loadPartialView('/ComplexPackagesSelection/GetFilterResults', data, result => {

            $('#compPacksResultsContainer').html(result);

            this.refreshFilterItemCounts();
            this.complexPackageSelectionModule.setClickEvents();

            this.axLoading.HideLoadingIndicator(compPacksResultsContainer);
            //this.axLoading.HideLoadingIndicator(compPacksResultsSearchButton);
        }, {
            dataType: 'html'
        });
    }
    //refreshFilterItemCounts
    refreshFilterItemCounts() {
        AxessViewer.loadPartialView('/ComplexPackagesSelection/GetFilterItemCount', '', resultFilter => {
            for (let i = 0; i < resultFilter.activities.length; i++) {
                const element = resultFilter.activities[i];
                const name = this.identifierActivity + element.Item1;
                this.setActivitySpanValues(name, element.Item2);
            }

            for (let i = 0; i < resultFilter.contents.length; i++) {
                const element = resultFilter.contents[i];
                const name = this.identifierContent + element.Item1;
                this.setContentSpanValues(name, element.Item2);
            }

            for (let i = 0; i < resultFilter.durations.length; i++) {
                const element = resultFilter.durations[i];
                const name = this.identifierDuration + element.Item1;
                this.setDurationSpanValues(name, element.Item2);
            }

            for (let i = 0; i < resultFilter.ageGroups.length; i++) {
                const element = resultFilter.ageGroups[i];
                const name = this.identifierAgeGroup + element.Item1;
                this.setAgeGroupSpanValues(name, element.Item2);
            }

            for (let i = 0; i < resultFilter.skillLevels.length; i++) {
                const element = resultFilter.skillLevels[i];
                const name = this.identifierSkillLevel + element.Item1;
                this.setSkillLevelSpanValues(name, element.Item2);
            }
        }, {
            dataType: 'json'
        });
    }

    // prepareData
    prepareData() {
        let fromDate = '';

        if (this.complexPackageSearchBarModule.dateFrom != undefined) {
            fromDate = this.complexPackageSearchBarModule.dateFrom.format('YYYY-MM-DD');
        }

        let toDate = '';

        if (this.complexPackageSearchBarModule.dateTo != undefined) {
            toDate = this.complexPackageSearchBarModule.dateTo.format('YYYY-MM-DD');
        }

        let data = {
            Activities: [],
            Durations: [],
            AgeGroups: [],
            SkillLevels: [],
            Contents: [],
            PriceRangeMin: this.priceRangeMin,
            PriceRangeMax: this.priceRangeMax,
            FromDate: fromDate,
            ToDate: toDate
        }

        $('.compPack_filter_item_activity').each((i, obj) => {
            let check = $(obj).prop('checked');
            let id = $(obj).attr('data-activity-id');

            if (check) {
                data.Activities.push(id);
            }
        });

        $('.compPack_filter_item_content').each((i, obj) => {
            let check = $(obj).prop('checked');
            let id = $(obj).attr('data-content-id');

            if (check) {
                data.Contents.push(id);
            }
        });

        $('.compPack_filter_item_duration').each((i, obj) => {
            let check = $(obj).prop('checked');
            let id = $(obj).attr('data-duration-id');

            if (check) {
                data.Durations.push(id);
            }
        });

        $('.compPack_filter_item_ageGroup').each((i, obj) => {
            let check = $(obj).prop('checked');
            let id = $(obj).attr('data-ageGroup-id');

            if (check) {
                data.AgeGroups.push(id);
            }
        });

        $('.compPack_filter_item_skillLevel').each((i, obj) => {
            let check = $(obj).prop('checked');
            let id = $(obj).attr('data-skillLevel-id');

            if (check) {
                data.SkillLevels.push(id);
            }
        });

        return data;
    }
    //setActivitySpanValues
    setActivitySpanValues(identifier: string, newValue: string) {
        for (let i = 0; i < this.checkBoxesActivity.length; i++) {
            if (this.checkBoxesActivity[i].identifier == identifier) {
                this.checkBoxesActivity[i].setSpanValue(newValue);
                if (this.hideEmptyActivities) {
                    this.hideZeroCounts(this.checkBoxesActivity[i], newValue);
                }
            }
        }
    }
    //setActivitySpanValues
    setContentSpanValues(identifier: string, newValue: string) {
        for (let i = 0; i < this.checkBoxesContent.length; i++) {
            if (this.checkBoxesContent[i].identifier == identifier) {
                this.checkBoxesContent[i].setSpanValue(newValue);
                if (this.hideEmptyContents) {
                    this.hideZeroCounts(this.checkBoxesContent[i], newValue);
                }
            }
        }
    }
    //setDurationSpanValues
    setDurationSpanValues(identifier: string, newValue: string) {
        for (let i = 0; i < this.checkBoxesDuration.length; i++) {
            if (this.checkBoxesDuration[i].identifier == identifier) {
                this.checkBoxesDuration[i].setSpanValue(newValue);
                if (this.hideEmptyDuration) {
                    this.hideZeroCounts(this.checkBoxesDuration[i], newValue);
                }
            }
        }
    }
    //setAgeGroupSpanValues
    setAgeGroupSpanValues(identifier: string, newValue: string) {
        for (let i = 0; i < this.checkBoxesAgeGroups.length; i++) {
            if (this.checkBoxesAgeGroups[i].identifier == identifier) {
                this.checkBoxesAgeGroups[i].setSpanValue(newValue);
                if (this.hideEmptyAgeGroup) {
                    this.hideZeroCounts(this.checkBoxesAgeGroups[i], newValue);
                }
            }
        }
    }
    //setSkillLevelSpanValues
    setSkillLevelSpanValues(identifier: string, newValue: string) {
        for (let i = 0; i < this.checkBoxesSkillLevels.length; i++) {
            if (this.checkBoxesSkillLevels[i].identifier == identifier) {
                this.checkBoxesSkillLevels[i].setSpanValue(newValue);
                if (this.hideEmptySkiLevel) {
                    this.hideZeroCounts(this.checkBoxesSkillLevels[i], newValue);
                }
            }
        }
    }
    // hideZeroCounts
    hideZeroCounts(axCheckBox: AxCheck, newValue: string) {
        let i: number = + newValue;

        if (i == 0) {
            axCheckBox.hideCheckBox();
        } else {
            axCheckBox.showCheckBox();
        }
    }
    // setupResetButtons
    setupResetButtons() {
        this.setupDesktopResetButton();
        this.setupMobileResetButton();
    }
    // setupDesktopResetButton
    setupDesktopResetButton() {
        document.querySelector('.compPack_filter_reset_btn_activity').addEventListener('click', (e: Event) => this.resetActivityFilter(true));
        document.querySelector('.compPack_filter_reset_btn_content').addEventListener('click', (e: Event) => this.resetContentFilter(true));
        document.querySelector('.compPack_filter_reset_btn_duration').addEventListener('click', (e: Event) => this.resetDurationFilter(true));
        document.querySelector('.compPack_filter_reset_btn_age').addEventListener('click', (e: Event) => this.resetAgeFilter(true));
        document.querySelector('.compPack_filter_reset_btn_skiLevel').addEventListener('click', (e: Event) => this.resetSkiLevelFilter(true));
        document.querySelector('.compPack_filter_reset_btn_price').addEventListener('click', (e: Event) => this.resetPriceFilter());
        document.querySelector('.compPack_filter_reset_btn_all').addEventListener('click', (e: Event) => this.resetAllFilters());
    }
    // setupMobileResetButton
    setupMobileResetButton() {
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_activity').addEventListener('click', (e: Event) => this.resetActivityFilter(true));
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_content').addEventListener('click', (e: Event) => this.resetContentFilter(true));
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_duration').addEventListener('click', (e: Event) => this.resetDurationFilter(true));
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_age').addEventListener('click', (e: Event) => this.resetAgeFilter(true));
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_skiLevel').addEventListener('click', (e: Event) => this.resetSkiLevelFilter(true));
        document.querySelector('.compack_filter_mobile_content .compPack_filter_reset_btn_price').addEventListener('click', (e: Event) => this.resetPriceFilter());
        document.querySelector('.lessones_filter_mobile_holder .lessons_filter_molbile_close_button').addEventListener('click', (e: Event) => this.resetAllFilters());
    }
    // resetActivityFilter
    resetActivityFilter(reload: boolean) {
        for (let i = 0; i < this.checkBoxesActivity.length; i++) {
            this.checkBoxesActivity[i].resetCheckBox();
        }

        if (reload) {
            this.loadFilteredResults();
        }
    }
    // resetContentFilter
    resetContentFilter(reload: boolean) {
        for (let i = 0; i < this.checkBoxesContent.length; i++) {
            this.checkBoxesContent[i].resetCheckBox();
        }

        if (reload) {
            this.loadFilteredResults();
        }
    }
    // resetDurationFilter
    resetDurationFilter(reload: boolean) {
        for (let i = 0; i < this.checkBoxesDuration.length; i++) {
            this.checkBoxesDuration[i].resetCheckBox();
        }

        if (reload) {
            this.loadFilteredResults();
        }
    }
    // resetAgeFilter
    resetAgeFilter(reload: boolean) {
        for (let i = 0; i < this.checkBoxesAgeGroups.length; i++) {
            this.checkBoxesAgeGroups[i].resetCheckBox();
        }

        if (reload) {
            this.loadFilteredResults();
        }
    }
    // resetSkiLevelFilter
    resetSkiLevelFilter(reload: boolean) {
        for (let i = 0; i < this.checkBoxesSkillLevels.length; i++) {
            this.checkBoxesSkillLevels[i].resetCheckBox();
        }

        if (reload) {
            this.loadFilteredResults();
        }
    }
    // resetPriceFilter
    resetPriceFilter() {
        this.rangeSliderDesktop.data("ionRangeSlider").reset();
        this.rangeSliderMobile.data("ionRangeSlider").reset();
    }
    // resetAllFilters
    resetAllFilters() {
        this.resetActivityFilter(false);
        this.resetContentFilter(false);
        this.resetDurationFilter(false);
        this.resetAgeFilter(false);
        this.resetSkiLevelFilter(false);
        this.resetPriceFilter();
    }
}
